import { mutationAdd, type AddHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRubricCache } from './cache'
import { type RecordingRubricAddInput, type RecordingRubricAddSuccess, toResponseError } from '@terros/common'

export function useAddRubric(): AddHookResponse<RecordingRubricAddInput, RecordingRubricAddSuccess> {
  const mutation = useTantalimMutation<RecordingRubricAddInput, RecordingRubricAddSuccess>({
    url: '/recording/rubric/add',
  })
  const cache = useRubricCache()

  async function add(input: RecordingRubricAddInput): Promise<RecordingRubricAddSuccess> {
    try {
      const result = await mutation.mutateAsync(input)
      cache.clearList()
      return result
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
